import { JobRunDayField } from "@/features/job/job-run/JobRunDayField";
import type { JobRunSettingsProps } from "@/features/job/job-run/jobRun.types";
import { toJobRunInputWith, toJobRunText } from "@/features/job/job-run/jobRun.utils";

/** Import order statuses' settings: the day whose built TOE, Toll and eStore snapshots it imports. */
export const JobRunImportOrderStatuses = (props: JobRunSettingsProps) => {
  const { input, onChange } = props;

  const handleDateChange = (value: string) => {
    const next = toJobRunInputWith(input, "date", value);
    onChange(next);
  };

  return (
    <JobRunDayField
      disableFuture
      format="yyMMdd"
      helperText="Imports that day's built TOE, Toll and eStore snapshots."
      label="Day"
      onChange={handleDateChange}
      value={toJobRunText(input, "date")}
    />
  );
};
